<template>
  <div>
    <v-card class="pa-4">
      <p class="text-2xl ma-5 mb-9">
        Etes vous sur de vouloir supprimer ({{ name }})? <br />
        Cela supprimera également définitivement tout ce qui a été enregistré
        concernant ce projet.
      </p>
      <v-row class="mx-1 my-3">
        <v-card-text>
          <v-form ref="confirmationForm">
            <v-row>
              <v-col cols="12">
                <v-btn
                  color="primary"
                  class="me-3 mt-3"
                  @click.native="deleteEntry"
                  >Supprimer
                </v-btn>
                <v-btn
                  color="secondary"
                  outlined
                  class="mt-3"
                  @click.native="$emit('openDialog', false)"
                >
                  Annuler
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import axios from "@axios";
import store from "@/store";

export default {
  name: "ProjectsDelConfirmation",
  props: {
    dialogOpen: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    async deleteEntry() {
      const { status } = await axios.delete(`/rmra-projects/${this.id}`);
      if (status === 204) {
        await store.dispatch("app/setSnackBar", {
          show: true,
          text: `Le projet ${this.name} et toutes ses références ont été supprimés.`,
          color: "success",
          timeout: 4000,
        });
      }
    },
  },
};
</script>
